<template>
    <div>
     
        <el-table class="feedback-table" :data="feedbacklist" border>
            <el-table-column prop="" type="index" align="center" label=""></el-table-column>
            <el-table-column prop="feedback_id" align="center" label="反馈id"></el-table-column>
            <el-table-column prop="user_id" align="center" label="用户编号"></el-table-column>
            <el-table-column prop="contact" align="center" label="联系人"></el-table-column>
            <el-table-column prop="content" align="center" label="反馈内容"></el-table-column>
            <el-table-column  label="类别" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.label == 1">BUG</span>
                    <span v-else-if="scope.row.label == 2">意见</span>
                    <span v-else-if="scope.row.label == 3">吐槽</span>
                    <span v-else-if="scope.row.label == 4">吐槽</span>
                </template>
            </el-table-column>
            <el-table-column class="feedback-box" prop="" align="center" label="反馈图片" width="300">
                <template slot-scope="scope">
                    <div class="item-all" style="display: flex; width: 100%;height: 100%;">
                        <div class="item" v-for="(item, index) in scope.row.images" :key="index">
							<!-- {{item || 'tupian '}} -->
                            <img :src="item" alt="" style="height: 50px;width: 100px;">
							<!-- <el-image v-if="item" :src="item"
							  width="50" height="50" /> -->
							 <!-- <el-image
							        style="width: 100px; height: 100px"
							        :src="item"
							        :preview-src-list="item"></el-image> -->
                        </div>
						
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.value"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="reply(scope.row.feedback_id, scope.row.value)">
                    </el-switch>
                    <span style="color: #00a2ff;" v-if="scope.row.status == 1">（未读）</span>
                    <span style="color: #1e1e1e;" v-else>（已读）</span>
                </template>
            </el-table-column>
        </el-table>
         <!--分页-->
      <div class="pagination">
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageinfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageinfo.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
      </div>
    </div>
</template>

<script>
import request from '@/utils/request'
export default{
    data() {
        return{
            
            total: 10,
            feedbacklist: [],
            pageinfo: {
                page: 1,
                rows: 10
            }
        }
    },
    created() {
        this.getdata()
    },
    methods: {
        handleCurrentChange(e) {
            this.pageinfo.page = e 
            this.getdata()
        },
        handleSizeChange(e) {
            this.pageinfo.rows = e 
            this.getdata()
        },
        getdata() {
            let that = this
            request._post('/shop/waiter.feedback/waiterList', this.pageinfo).then(res=> {
                console.log('122', res);
                res.data.data.forEach((item, index) => {
                    // item.images = 'https://shangmenfuwu.rchz.top/uploads/20220813/95a373e0f76aa17b5560c918ba503a5a.jpg,https://shangmenfuwu.rchz.top/uploads/20220813/95a373e0f76aa17b5560c918ba503a5a.jpg'
                    item.images = item.images.join(',').replace(/(]|"|\[)/ig,'').split(',')
					item.images = item.images.filter(e=>{
						return e 
					})
                    if (item.status == 1 ) {
                        item.value = false
                    }else {
                         item.value = true
                    }
                })
                that.feedbacklist =  res.data.data
                that.total = res.data.total
                console.log('that.feedbacklist', that.feedbacklist);
				
            })
        },
        reply(id, value) {
             let that = this
             let type = ''
             if (!value) {
                type = 1
             }else {
                type = 2
             }
            request._post('/shop/waiter.feedback/replyWaiter', {
                feedback_id: id,    
                status: type
            }).then(res=> {
                if (res.code == 1) {
                    console.log('成功');
                    that.getdata()
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.feedback-table{
    .feedback-box{
        .item-all{
            display: flex;
            .item{
                img{
                    width: 50px;
                    height: 50px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/supplier/feedback/index.vue